import { render, staticRenderFns } from "./TowerCardLite.vue?vue&type=template&id=029b2d40&scoped=true&"
import script from "./TowerCardLite.vue?vue&type=script&lang=js&"
export * from "./TowerCardLite.vue?vue&type=script&lang=js&"
import style0 from "./TowerCardLite.vue?vue&type=style&index=0&id=029b2d40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029b2d40",
  null
  
)

export default component.exports